<template>
  <rpm-input
    type="multiselect"
    class="w-full"
    optionValue="label"
    optionLabel="label"
    :options="question.options"
    :label="!noLabel ? question.label:''"
    :required="!noLabel ? question.required:''"
    :optional="!noLabel ? !question.required:''"
  ></rpm-input>
</template>

<script>
export default {
  name: "MultiselectAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
  },
};
</script>
